export default __webpack_public_path__ + "static/media/lawn-doctors-logo.574ae250.svg";